import Icon from '../components/Icon.vue'

Icon.register({
  'comments-dollar': {
    width: 576,
    height: 512,
    paths: [
      {
        d: 'M416 192c0 88.4-93.1 160-208 160-41 0-79.1-9.2-111.3-25-21.8 12.7-52.2 25-88.7 25h0c-4.4 0-8-3.6-8-8 0-1.8 1-4.2 2.2-5.5 0.3-0.3 22.4-24.3 35.8-54.5-23.8-26-38-57.7-38-92 0-88.4 93.1-160 208-160s208 71.6 208 160zM192 288c0 4.4 3.6 8 8 8h16c4.4 0 8-3.6 8-8v-16.1c23.6-0.6 42.7-20.5 42.7-45.1 0-20-13-37.8-31.6-43.4l-45-13.5c-5.2-1.5-8.8-6.8-8.8-12.7 0-7.3 5.3-13.2 11.8-13.2h28.1c4.6 0 8.9 1.3 12.8 3.7 3.2 2 7.4 1.9 10.1-0.7l11.8-11.2c3.5-3.4 3.3-9.2-0.6-12.1-9.1-6.8-20.1-10.8-31.4-11.3v-16.3c0-4.4-3.6-8-8-8h-16c-4.4 0-8 3.6-8 8v16.1c-23.6 0.6-42.7 20.5-42.7 45.1 0 20 13 37.8 31.6 43.4l45 13.5c5.2 1.5 8.8 6.8 8.8 12.7 0 7.3-5.3 13.2-11.8 13.2h-28.1c-4.6 0-9-1.3-12.8-3.7-3.2-2-7.4-1.9-10.1 0.7l-11.8 11.2c-3.5 3.4-3.3 9.2 0.6 12.1 9.1 6.8 20.1 10.8 31.4 11.3v16.3zM538 412c13.4 30.3 35.5 54.2 35.8 54.5 2.2 2.3 2.8 5.7 1.5 8.7-1.3 2.9-4.1 4.8-7.3 4.8-36.6 0-66.9-12.3-88.7-25-32.2 15.7-70.3 25-111.3 25-86.2 0-160.2-40.4-191.7-97.9 10.4 1.1 21 1.9 31.7 1.9 132.3 0 240-86.1 240-192 0-6.8-0.5-13.5-1.3-20.1 75.8 23.9 129.3 81.1 129.3 148.1 0 34.3-14.1 66-38 92z'
      }
    ]
  }
})



//////////////////
// WEBPACK FOOTER
// ./~/vue-awesome/icons/comments-dollar.js
// module id = 1232
// module chunks = 0